/*************************************************/
/* MENU                                          */
/*************************************************/
import customEventsNames from './../customEventsNames';

export function menu() {
    const menuPanel = document.querySelector(".menu-panel");
    const menuButton = document.querySelector(".menu-button");
    const closeButton = document.querySelector(".menu-panel--icon");
    const overlays = document.querySelectorAll('.overlay');
    const panelActiveBodyClass = "panel-active";

    const toggleMenuPanel = (event) => {
        event.stopPropagation(); // Prevent event bubbling
        const isOpen = menuPanel.classList.toggle('open');
        document.body.classList.add(panelActiveBodyClass);

        const overlay = menuPanel.nextElementSibling;
        overlay.style.opacity = isOpen ? ".6" : "0";
        overlay.style.pointerEvents = isOpen ? "auto" : "none"; // Ensure clicks go through the overlay when it's hidden
    };

    const closeMenuPanel = (event) => {
        event.stopPropagation(); // Prevent event bubbling
        menuPanel.classList.remove('open');
        document.body.classList.remove(panelActiveBodyClass);

        const overlay = menuPanel.nextElementSibling;
        overlay.style.opacity = "0";
        overlay.style.pointerEvents = "none"; // Ensure clicks go through the overlay when it's hidden

    };

    const handleBodyClick = (event) => {
        if (!menuPanel.contains(event.target) && !menuButton.contains(event.target)) {
            closeMenuPanel(event);
        }
    };

    const init = () => {
        if (menuButton) {
            menuButton.addEventListener('click', toggleMenuPanel);
        }
        closeButton.addEventListener('click', closeMenuPanel);
        document.body.addEventListener('click', handleBodyClick);
        menuPanel.addEventListener('click', (event) => event.stopPropagation()); // Prevent menu item clicks from closing the menu
    };

    init();
}
